import EventLibrary from './EventLibrary';
import SkinLibrary from './SkinLibrary';
import SoundLibrary from './SoundLibrary';


export default class Library {

    constructor(game) {
        this.game = game;
        this.soundLibrary = new SoundLibrary(this);
        this.eventLibrary = new EventLibrary(this);
        this.skinLibrary = new SkinLibrary(this);
        this.loadingCount = 3;
        this.loadingCounter = this.loadingCount;
        this.loaded = false;
        window.addEventListener('library-event',
            this.receiveMessage);
    }

    receiveMessage = (e) => {
        const receivedMessage = e.detail;
        this.loadingCounter--;
        let packageType = receivedMessage.package.type;
        switch (packageType) {
        case 'Sound':
            let soundLibrary = receivedMessage.package.data.library_data;
            this.soundLibrary.receiveLibrary(soundLibrary);
            break;
        case 'Event':
            let eventLibrary = receivedMessage.package.data.library_data;
            this.eventLibrary.receiveLibrary(eventLibrary);
            break;
        case 'Choice':
            let choiceLibrary = receivedMessage.package.data.library_data;
            this.choiceLibrary.receiveLibrary(choiceLibrary);
            break;
        case 'Ship':
            let shipLibrary = receivedMessage.package.data.library_data;
            this.shipLibrary.receiveLibrary(shipLibrary);
            break;
        case 'Skin':
            let skinLibrary = receivedMessage.package.data.library_data;
            this.skinLibrary.receiveLibrary(skinLibrary);
            break;
        case 'Bridge':
            let bridgeLibrary = receivedMessage.package.data.library_data;
            this.bridgeLibrary.receiveLibrary(bridgeLibrary);
            break;
        default:
            break;
        }
        if (!this.loadingCounter) this.loaded = true;
    }

}
